import type { PropsWithChildren } from "react";
import { Heading } from "@repo/ui/components/Base/Heading";
import { cn } from "@repo/shared/utils";
import type { ClassNameValue } from "tailwind-merge";

interface ManagementHeaderProps extends PropsWithChildren {
  id?: string;
  title: string;
  icon?: React.ReactNode;
  className?: ClassNameValue;
}
export const PageHeader = ({
  id,
  title,
  icon,
  children,
  className,
}: ManagementHeaderProps) => {
  return (
    <div className={cn("flex flex-row items-center", className)} id={id}>
      {icon}
      <Heading title={title} />
      <div className="flex-grow" />
      {children}
    </div>
  );
};
